import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import IconFreska from 'assets/images/icon-freska.svg';
import IconNav from 'assets/images/icon-nav.svg';

import { toggleNav } from 'store/nav';

export class TopBar extends Component {
  static propTypes = {
    onToggleNav: PropTypes.func.isRequired
  };

  handleClickToggle = event => {
    this.props.onToggleNav();
    event.preventDefault();
  };

  render() {
    return (
      <div className="top-bar">
        <div className="top-bar__brand">
          <img src={IconFreska} alt="Freska" />
        </div>

        <a
          className="top-bar__toggle"
          onClick={this.handleClickToggle}
          href="/"
        >
          <img src={IconNav} alt="Nav" />
        </a>
      </div>
    );
  }
}

const mapDispatchToProps = {
  onToggleNav: toggleNav
};

export default connect(null, mapDispatchToProps)(TopBar);



// WEBPACK FOOTER //
// ./src/containers/TopBar/TopBar.js